<template>
  <form class="vacancy-form__form form" @submit.prevent="sendForm" ref="formCentralized">
    <div class="form__body" v-show="!success">
      <div class="form__items form__items--2">
        <div class="form__item form__item--2">
          <div class="default-input" :class="{'error':errors['form_text_9']}">
            <div class="default-input__body" data-sticky-label>
              <input class="default-input__input" type="text" :placeholder="fieldNamePlaceholder"
                     @input="clearErrors" v-model="form.form_text_9">
              <label class="default-input__label">{{ field1 }}</label>
            </div>
            <div class="default-input__error"><span>{{ errors['form_text_9'] }}</span></div>
          </div>
        </div>
        <div class="form__item">
          <div class="default-input" :class="{'error':errors['form_text_10']}">
            <div class="default-input__body" data-sticky-label>
              <input class="default-input__input" type="text" placeholder="E-mail"
                     @input="clearErrors" v-model="form.form_text_10">
              <label class="default-input__label">E-mail</label>
            </div>
            <div class="default-input__error"><span>{{ errors['form_text_10'] }}</span></div>
          </div>
        </div>
        <div class="form__item">
          <div class="default-input" :class="{'error':errors['form_text_11']}">
            <div class="default-input__body" data-sticky-label>
              <input class="default-input__input" type="tel" inputmode="numeric"
                     placeholder="Телефон" data-input-mask="phone" @input="clearErrors"
                     v-model="form.form_text_11">
              <label class="default-input__label">{{ field2 }}</label>
            </div>
            <div class="default-input__error"><span>{{ errors['form_text_11'] }}</span></div>
          </div>
        </div>
        <div class="form__item form__item--2">
          <div class="default-textarea" data-sticky-label>
            <div class="default-textarea__body">
                                    <textarea class="default-textarea__textarea"
                                              placeholder="Задайте вопрос или оставьте комментарий (необязательно)"
                                              rows="1" @input="clearErrors" v-model="form.form_textarea_12"></textarea>
              <label class="default-textarea__label">{{ field3 }}</label>
            </div>
          </div>
        </div>
        <div class="form__item form__item--2">
          <div class="default-file">
            <div class="default-file__input">
              <input class="default-file__input-input" type="file" id="file" name="form_file_13" accept=".doc, .docx, .pdf, .png, .jpeg, .txt"
                     ref="file" v-on:change="handleFileUpload()">
              <label class="default-file__input-label" for="file"><span>{{ field4 }}</span></label>
            </div>
            <div class="default-file__preview">
              <div class="preview"></div>
            </div>
          </div>
        </div>
        <div class="form__item form__item--2">
          <div class="default-input">
            <div class="default-input__body">
              <input class="default-input__input" type="text"
                     placeholder="Или вставьте ссылку на резюме hh.ru" @input="clearErrors"
                     v-model="form.form_text_14">
              <label class="default-input__label">{{ field5 }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="form__submit">
        <button class="form__submit-btn default-btn default-btn--green" type="submit">{{ fieldBtn }}
          <svg class="default-btn__icon" aria-hidden="true">
            <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-arrow-right"></use>
          </svg>
        </button>
        <p class="form__policy">{{ policy1 }} <a class="link link--base" :href="agreement"
                                                 target="_blank">{{ policy2 }}</a>
          {{ policy3 }} <a class="link link--base" :href="policy" target="_blank">{{ policy4 }}</a></p>
      </div>
    </div>
    <div class="form__confirm" v-show="success">
      <p>{{ confirm1 }}</p>
      <p>{{ confirm2 }}</p>
    </div>
  </form>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: "VacancyForm",
  data() {
    return {
      form: {
        form_text_9: '',
        form_text_10: '',
        form_text_11: '',
        form_textarea_12: '',
        form_file_13: '',
        form_text_14: '',
      },
      application: '',
      errors: {},
      success: false,
      file: '',
    }
  },
  props: {
    agreement: String,
    policy: String,
    code: String,
    vacancy: String,
    vacancyName: String,
    language: {
      type: [String],
      default: 'ru'
    },
    fieldNamePlaceholder: {
      type: [String],
      default: BX.message('FORM_FIELD_NAME_PLACEHOLDER')
    },
    field1: {
      type: [String],
      default: BX.message('VACANCIES_FORM_FIELD_1')
    },
    field2: {
      type: [String],
      default: BX.message('VACANCIES_FORM_FIELD_2')
    },
    field3: {
      type: [String],
      default: BX.message('VACANCIES_FORM_FIELD_3')
    },
    field4: {
      type: [String],
      default: BX.message('VACANCIES_FORM_FIELD_4')
    },
    field5: {
      type: [String],
      default: BX.message('VACANCIES_FORM_FIELD_5')
    },
    fieldBtn: {
      type: [String],
      default: BX.message('VACANCIES_FORM_BTN')
    },
    policy1: {
      type: [String],
      default: BX.message('FORM_POLICY_1')
    },
    policy2: {
      type: [String],
      default: BX.message('FORM_POLICY_2')
    },
    policy3: {
      type: [String],
      default: BX.message('FORM_POLICY_3')
    },
    policy4: {
      type: [String],
      default: BX.message('FORM_POLICY_4')
    },
    confirm1: {
      type: [String],
      default: BX.message('VACANCIES_FORM_CONFIRM_1')
    },
    confirm2: {
      type: [String],
      default: BX.message('VACANCIES_FORM_CONFIRM_2')
    },
  },
  computed: {
    ...mapState(['moduleWebForm']),
    result() {
      if (this.moduleWebForm.formArray)
        return Object.values(this.moduleWebForm.formArray)
      else
        return []
    }
  },
  methods: {
    sendForm() {
      let formData = new FormData
      formData.set('data', JSON.stringify(this.form))
      if (this.file) {
        formData.append('file[0]', this.file);
      }
      formData.append('formCode', this.code)
      formData.append('vacancyCode', this.vacancy)
      formData.append('vacancyName', this.vacancyName)
      formData.append('requiredFields[]', 'form_text_9');
      formData.append('requiredFields[]', 'form_text_10');
      formData.append('requiredFields[]', 'form_text_11');
      formData.append('language', this.language);

      if (window._tmr) {
        window._tmr.push({
          type: 'reachGoal',
          id: 3352405,
          goal: 'click_hr_button'
        });
      }

      this.$axios.post('/api/webform/add/',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      )
          .then((response) => {
            if ('data' in response.data) {
              this.$cookies.config(60 * 60 * 24 * 30, '');

              // console.log(this.$cookies.get('user'));
              // let user = { id:1, name:'Journal',session:'25j_7Sl6xDq2Kc3ym0fmrSSk2xV2XkUkX' };
              // this.$cookies.set('user', user);
              // console.log(this.$cookies.get('user'));

              let cookies = this.$cookies.get('submitted_vacancies');
              if (cookies)
                cookies += ', ' + this.vacancy;
              else
                cookies = this.vacancy;

              this.$cookies.set('submitted_vacancies', cookies);

              // let cookies2 = this.$cookies.get('submitted_vacancies');

              this.form = {}
              this.success = true
              if (document.querySelector('.default-file__preview span'))
                document.querySelector('.default-file__preview span').click()

              setTimeout(() => {
                this.success = false
              }, 5000)
            } else {
              let message = JSON.parse(response.data.message)
              this.errors = message.errors

              const targetElement = this.$refs['formCentralized'];
              if (window.locoScroll) {
                window.locoScroll.scrollTo(targetElement, {
                  offset: document.querySelector('.header') ? -(document.querySelector('.header').offsetHeight + 50) : 0,
                })
              } else {
                const yOffset = -100;
                const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
              }
            }
          })
          .catch(() => {
            console.log('catch')
          });
    },
    clearErrors() {
      this.errors = {};
    },
    // onFileChange(e) {
    //     var files = e.target.files || e.dataTransfer.files;
    //     if (!files.length)
    //         return;
    //     this.createImage(files[0]);
    // },
    // createImage(file) {
    //     // var image = new Image();
    //     var reader = new FileReader();
    //     var vm = this;
    //
    //     reader.onload = (e) => {
    //         vm.image = e.target.result;
    //     };
    //     reader.readAsDataURL(file);
    // },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    }
  },
  created() {
    this.$store.dispatch('getForm', this.code)
  }
}
</script>
